import axios, { AxiosInstance } from 'axios';

const apiClient: AxiosInstance = axios.create({
    baseURL: window.location.origin + '/backend/api', // Base URL for the API
    headers: {
        'Content-Type': 'application/json', // Set the default content type
    },

});

export default apiClient;